export default "__VITE_ASSET__Be59Sn_K__"